import * as React from "react";

import { auth } from "../../firebase";
import { connect, useDispatch } from 'react-redux';
import config from '../../config';
import { resetRegFlow } from '../actions/registrationActions';
import { navigateTop } from '../routing/router-utils';
import RegFlowHeader from "./RegFlowHeader";
import GreenPageBody from '../layout/GreenPageBody';
import BasicButton from '../styleguide/BasicButton';
import LinkAccountsCallout from '../payment/LinkAccountsCallout';
import completeShield from '../../assets/completeShield.png';

import styles from './Registration.module.css';

const RegistrationComplete = ({
  name,
  email,
  password,
  street_address,
  city,
  state,
  zip_code,
  apartment_number,
  dob={},
  tel_number,
  photo_ids={},
  marketing_accepted,
  return_to_path
}) => {  

  // Show debug info in QA/Dev
  const isDev = window.location.host !== 'app.ziprun.com';
  const aeroPayEnabled = config.AEROPAY_ENABLED;
  const dispatch = useDispatch();

  const [error, setError] = React.useState();
  const [showRegInfo, setShowRegInfo] = React.useState();
  
  const signInNewUser = (email, password) => {
    auth.signInWithEmailAndPassword(email, password).catch(error => {
      setError(`Error signing in with password and email! ${error}`);
      console.error("Error signing in with password and email", error);
    });
  }; 

  // Sign the user in! ( esp for bank account linking ).
  React.useEffect(() => {
    if (email) {
      signInNewUser(email, password);
      // Email verify not needed at the moment
      // auth.currentUser.sendEmailVerification();
    }
  }, [email, password]);

  return (
    <div className={styles.formOnlyPage}>
      <GreenPageBody />
      <RegFlowHeader  pageTitle="Registration Complete" />
      <div className={`${styles.regFlowForm} ${styles.regFlowCompleteForm}`}>
        <div className={styles.formHeader}>Sign Up Completed!</div>
        <img alt="" src={completeShield} className={styles.completeShield} />
        
        { aeroPayEnabled && 
          <div className={styles.aeropayCallout}>
            <div className={styles.formHeaderSecondary}>Link Your Bank Account For Order&nbsp;Payment</div>
            <div className={styles.aeropayNote}>
              Zip Run uses 
              {' '}<a className={styles.aeropayLink} target="_blank" rel="noopener noreferrer" href="https://www.aeropay.com">AeroPay</a>{' '}
              for payment on all pickup and delivery orders. Link&nbsp;your bank account now with AeroPay and
              you'll be all set at checkout to complete your order. If you prefer, you can complete this step during&nbsp;checkout.
            </div>
            <LinkAccountsCallout onGreen={true} />
          </div>
        }

        { (!return_to_path || return_to_path === '/')
          ? <button
              className={`${styles.formButton} ${styles.formSubmit}`}
              onClick={() => {
                // flush user data from redux
                dispatch(resetRegFlow());
                navigateTop('/', { replace: true });
              }}>
              Start Shopping
            </button>
          : <button
              className={`${styles.formButton} ${styles.formSubmit}`}
              onClick={() => {
                // flush user data from redux
                dispatch(resetRegFlow());
                navigateTop(`${return_to_path}`, { replace: true });
              }}>
              Continue Shopping
            </button>
        }
        { error &&
          <div className={styles.formError}>
            {error}
          </div>
        }
      </div>   
    
      { isDev 
        ? showRegInfo 
          ? <div style={{marginTop: '3rem'}}> 
              <BasicButton text="Hide Registration Data" handleClick={() => setShowRegInfo(false)} />
              <div style={{ textAlign:'left', margin:'1rem auto', width: '75vw' }}>
                <div>Data being sent (DEBUG):</div>
                <div>{name}</div>
                <div>{email}</div>
                <div>{password}</div>  
                <div>{street_address}</div>
                <div>{city}</div>
                <div>{zip_code}</div>
                <div>{state}</div>
                <div>{apartment_number}</div> 
                <div>{dob['day']}</div>
                <div>{dob['month']}</div>
                <div>{dob['year']}</div>
                <div>{tel_number}</div>
                <div>Accept Marketing: {marketing_accepted ? 'true' : 'false'}</div>
                <div>{photo_ids['primary'] && photo_ids['primary'].path}</div>
                <div>{photo_ids['primary'] && photo_ids['primary'].url}</div>
                <div>{photo_ids['secondary'] && photo_ids['secondary'].path}</div>
                <div>{photo_ids['secondary'] && photo_ids['secondary'].url}</div>
              </div>
            </div> 
          : <div style={{marginTop: '3rem'}}> 
              <BasicButton text="Show Registration Data" handleClick={(event) => { event.preventDefault(); setShowRegInfo(true);}} />
            </div>
        : null  
      }
    </div> 
  );
}

const mapStateToProps = (state)=>{
  return {
    name: state.name,
    email: state.email,
    password: state.password,
    street_address: state.street_address,
    city: state.city,
    state: state.state,
    zip_code: state.zip_code,
    apartment_number: state.apartment_number,
    dob: state.dob,
    tel_number: state.tel_number,
    photo_ids: state.photo_ids,
    marketing_accepted: state.marketing_accepted,
    return_to_path: state.return_to_path /* set via sign up link */
  }
}

export default connect(mapStateToProps)(RegistrationComplete);
